module.exports = __webpack_public_path__ + "static/media/IconoCompetenciasGenericas.b07c19db.svg";